// 通知

/** ********************** 通知设置 *************************/
// 通知角色
export const LEAVE_NOTICE_TEXT = {
  1: '家长',
  2: '班主任',
  3: '家长',
  4: '任课老师', // isTeacher || isMoralEduTeacher || isClassEvaluationTeacher
  5: '自定义角色',
  6: '宿舍管理员',
  7: '学生',
  8: '德育考评老师', // isMoralEduTeacher
  9: '班级考评老师', // isClassEvaluationTeacher
  10: '值周老师', // isScheduleTeacher
  99: '自定义角色'
}

export const MODULE_NAME = {
  1: 'attendance', // 考勤;
  2: 'leave', // 请假;
  4: 'dorm', // 宿管;
  30: 'afterschool', //  班级放学;
  95: 'vehiclemanage' // 智慧停车
}
export const INFO_TYPE = {
  // 考勤
  1: {
    1: '上学',
    2: '下学',
    3: '迟到',
    9: '上学统计通知',
    10: '月统计通知'
  },
  // 请假
  2: {
    1: '请假通知',
    2: '离/到校通知',
    3: '撤销请假通知',
    20: '请假销假'
  },
  // 宿管
  4: {
    1: '归寝统计',
    2: '离寝统计',
    3: '未归寝提醒',
    4: '未离寝提醒',
    5: '归寝通知',
    6: '离寝通知'
  },
  // 30 班级放学
  30: {
    1: '放学通知',
    2: '学生未准时离校通知',
    3: '学生进入等候区通知',
    4: '延迟接送登记'
  },
  95: {
    1: '超时停车通知'
    // 2: '超时拉黑提醒通知'
  }
}

export const ALL_SETTING_LIST = {
  // 考勤
  1: () => {
    return [
      {
        id: 1,
        title: '上学通知',
        subTitle: '学生上学正常打卡，系统发送的通知',
        show: false
      },
      {
        id: 2,
        title: '下学通知',
        subTitle: '学生下学正常打卡，系统发送的通知',
        show: false
      },
      {
        id: 3,
        title: '迟到通知',
        subTitle: ''
      },
      {
        id: 9,
        title: '上学统计通知',
        subTitle: '学生上学打卡统计在上学时间后系统自动发送'
      },
      {
        id: 10,
        title: '月统计通知',
        subTitle: '次月第一个自然日8点，系统自动发送'
      }
    ]
  },
  // 请假
  2: (noticeType, isGray) => {
    return [
      {
        id: 1,
        title: '请假通知',
        subTitle: `请假审核通过后，通知${LEAVE_NOTICE_TEXT[noticeType]}。`
      },
      {
        id: 2,
        title: '离/到校通知',
        subTitle: `请假批准后，学生在智能门禁刷脸离校/到校，通知${LEAVE_NOTICE_TEXT[noticeType]}。`
      },
      {
        id: 3,
        title: '撤销通知',
        subTitle: `撤销已同意的请假，通知${LEAVE_NOTICE_TEXT[noticeType]}`
      }
    ].concat(
      isGray
        ? [
            {
              id: 20,
              title: '销假通知',
              subTitle: `学生销假后，通知${LEAVE_NOTICE_TEXT[noticeType]}`
            }
          ]
        : []
    )
  },
  // 4 宿管
  4: () => {
    return [
      {
        id: 1,
        title: '归寝统计'
      },
      {
        id: 3,
        title: '未归寝提醒',
        triggerConditions: [
          {
            conditionType: 3,
            title: '考勤结束前推送通知',
            value: '结束前{value}分钟',
            minValue: 1,
            maxValue: 60,
            defaultValue: 15,
            unit: '分钟'
          }
        ]
      },
      {
        id: 2,
        title: '离寝统计'
      },
      {
        id: 4,
        title: '未离寝提醒',
        triggerConditions: [
          {
            conditionType: 3,
            title: '考勤结束前推送通知',
            value: '结束前{value}分钟',
            minValue: 1,
            maxValue: 60,
            defaultValue: 15,
            unit: '分钟'
          }
        ]
      },
      {
        id: 5,
        title: '归寝通知'
      },
      {
        id: 6,
        title: '离寝通知'
      }
    ]
  },
  // 30 班级放学
  30: () => {
    return [
      {
        id: 1,
        title: '放学通知',
        subTitle: '学生开始放学后发送的通知'
      },
      {
        id: 2,
        title: '学生未准时离校通知',
        subTitle: ''
      },
      {
        id: 3,
        title: '学生进入等候区通知'
      },
      {
        id: 4,
        title: '延迟接送登记',
        subTitle: '延迟接送的家长提前进行上报',
        triggerConditions: [
          {
            value: '',
            conditionType: 2,
            period: 50400,
            threshold: 1
          }
        ]
      }
    ]
  },
  95: () => {
    return [
      {
        id: 1,
        title: '超时停车通知'
      }
      // {
      //   id: 2,
      //   title: '超时拉黑提醒通知'
      // }
    ]
  }
}

export const INIT_CONFIG_LIST = {
  // key: noticeType 通知组类型: 1、管理员 2、班主任 3、家长 4、任课老师 5、自定义 6、宿舍管理员
  // value: 参考 INFO_TYPE

  // 考勤
  1: {
    3: [1, 2],
    5: [9, 10],
    1: [3, 9, 10],
    2: [3, 9, 10],
    4: [3, 9, 10]
  },
  // 请假
  2: {
    3: [1, 2, 3, 20],
    2: [1, 2, 3, 20],
    4: [1, 3, 20],
    6: [1, 3, 20],
    5: [1, 3, 20]
  },
  // 4 宿管
  4: {
    3: [5, 6],
    2: [1, 3, 2, 4],
    6: [1, 3, 2, 4],
    5: [1, 3, 2, 4]
  },
  // 30 班级放学
  30: {
    3: [1, 2, 3, 4],
    2: [2],
    5: [2]
  },
  95: {
    3: [1, 2]
  }
}
/** ********************** 通知设置 *************************/

/** ********************** 通知外链 *************************/

export const REDIRECT_HASH = redirectType => {
  /*

attencedance#上下学通知_特殊文案(准时上学)#家长
attencedance#上下学通知_特殊文案(准时下学)#班主任
attencedance#上下学通知_特殊文案(迟到)#班主任_家长

flexleave#滞留生学生离校#家长

squirrel#学生上车通知#家长
squirrel#准备上车通知#家长
squirrel#学生上车刷卡通知#家长
squirrel#学生准备上校车刷卡#家长

squirrel#调代课申请审核通过#申请人

report#测温通知-体温异常发送通知#班主任_其他角色

*/
  let _toPath = ''
  switch (redirectType) {
    // attencedance#上学未打卡通知#班主任_家长
    // attencedance#下学未打卡通知#班主任_家长
    // attencedance#考勤部门日统计通知#班主任  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding7695755912aeb28035c2f4657eb6378f&platformSource=1#/?redircetHash=/attendance/index&dingDeptSelects=%7B%22deptDingId%22%3A513090883%2C%22deptType%22%3A3%7D&timePeriodId=
    // attencedance#考勤校区日统计通知#其他角色  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f&platformSource=1#/?redircetHash=/attendance/index&timePeriodId=1703993416985083905&inOutType=1&attendanceTime=12:21-20:20&campusId=426025287&dimDay=20221111&currentRole=99&type=1
    // 上学统计通知 http://tding.dev.moredian.com:8000/campusleave/?corpId=ding7695755912aeb28035c2f4657eb6378f&platformSource=1#/?redircetHash=%2Fattendance/index&dingDeptSelects=%7B%22deptDingId%22%3A291570384%2C%22deptType%22%3A3%7D&timePeriodId=1704499974017908736&inOutType=1&role=99&attendanceTime=16:00-18:00&campusId=291464443&dimDay=20220718&type=1
    case '1':
      _toPath = '/attendance/index'
      break
    //  attencedance#上下学通知(准时上学)#家长  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding7695755912aeb28035c2f4657eb6378f&platformSource=1#/?redircetHash=/attendance/PageAttendancePeopleCalendar&dingUserId=3000000000726275694&campusId=291464443&role=-1&dimDate=20221114&timestamp=1668393242679
    // attencedance#上下学通知(准时下学)#班主任  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding7695755912aeb28035c2f4657eb6378f&platformSource=1#/?redircetHash=/attendance/PageAttendancePeopleCalendar&dingUserId=3000000000726275694&campusId=291464443&role=-1&dimDate=20221114&timestamp=1668393242679
    // attencedance#上下学通知(迟到)#班主任_家长  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding7695755912aeb28035c2f4657eb6378f&platformSource=1#/?redircetHash=/attendance/PageAttendancePeopleCalendar&dingUserId=3000000000726275694&campusId=291464443&role=-1&dimDate=20221114&timestamp=1668393242679
    // attencedance#上下学通知_去人脸化(准时上学)#家长  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f&platformSource=1#/?redircetHash=/attendance/PageAttendancePeopleCalendar&timestamp=1660206271183&role=-1&currentRole=1&dimDate=20220811
    // attencedance#上下学通知_去人脸化(准时下学)#班主任  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f&platformSource=1#/?redircetHash=/attendance/PageAttendancePeopleCalendar&timestamp=1660206271183&role=-1&currentRole=1&dimDate=20220811
    // attencedance#上下学通知_去人脸化(迟到)#班主任_家长  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f&platformSource=1#/?redircetHash=/attendance/PageAttendancePeopleCalendar&timestamp=1660206271183&role=-1&currentRole=1&dimDate=20220811
    case '2':
      _toPath = '/attendance/PageAttendancePeopleCalendar'
      break
    // attencedance#考勤部门月统计通知#班主任  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f&platformSource=1#/?redircetHash=/attendance/pageAttendanceMonth&dingDeptIds=439925775&campusId=440263079&timeStart=20221001&timeEnd=20221031&type=1&deptName=八年级一班的别名修改最长授权&isCampus=false
    // attencedance#考勤校区月统计通知#其他角色  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f&platformSource=1#/?redircetHash=/attendance/pageAttendanceMonth&timeEnd=20220831&timeStart=20220801&campusId=426025287&currentRole=99&type=1&isCampus=true
    case '3':
      _toPath = '/attendance/pageAttendanceMonth'
      break
    // 请假：http://tding.dev.moredian.com:8000/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f#/?redircetHash=%2Fleave%2Findex&currentRole=1&stuDingId=3000000000026731356
    case '4':
      _toPath = '/leave/index'
      break
    // leave#请假-返校证明待提交通知#家长  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding47900f8ef296f9dba1320dcb25e91351&platformSource=1#/?redircetHash=/leave/history&currentRole=1&stuDingId=3000000000003230021&leaveId=1749453481149726720&timestamp=1668408875256
    // leave#请假-返校证明审核通过通知#家长  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding7695755912aeb28035c2f4657eb6378f&platformSource=1#/?redircetHash=/leave/history&currentRole=1&stuDingId=1648745234978&leaveId=1740949351414366208&timestamp=1660299756150
    // leave#请假 - 返校证明审核未通过通知#家长  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding7695755912aeb28035c2f4657eb6378f&platformSource=1#/?redircetHash=/leave/history&currentRole=1&stuDingId=1648745234978&leaveId=1740949351414366208&timestamp=1660299359021
    // leave#请假-返校证明待审核通知#班主任  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding7695755912aeb28035c2f4657eb6378f&platformSource=1#/?redircetHash=/leave/history&currentRole=2&leaveId=1742755625680502784&timestamp=1662022380183
    // leave#请假 - 家长未提交返校证明#班主任  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding7695755912aeb28035c2f4657eb6378f&platformSource=1#/?redircetHash=/leave/history&currentRole=2&timestamp=1660294166940
    case '5':
      _toPath = '/leave/history'
      break
    // flexleave#家长通知-学生滞留#家长  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f&platformSource=1#/?redircetHash=/arrived&role=1&studentDingId=1609851421833796601705&dimDay=20220705
    case '6':
      _toPath = '/arrived'
      break
    // flexleave#放学家长准时接送#家长  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding7695755912aeb28035c2f4657eb6378f&platformSource=1#/?redircetHash=/afterschool/guardian&code=513393259_20221012_2&bizCode=30_4_1&type=2&classDingId=513393259&campusId=407809596&timeStamp=1665569468557&role=-1&currentRole=1
    // dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding7695755912aeb28035c2f4657eb6378f&platformSource=1#/?redircetHash=/afterschool/guardian&code=513393259_20221012_1&bizCode=30_4_1&type=1&classDingId=513393259&campusId=407809596&timeStamp=1665569468557&role=-1&currentRole=1
    case '7':
      _toPath = '/afterschool/guardian'
      break
    // flexleave#放学家长延迟接送#班主任  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f&platformSource=1#/?redircetHash=/afterschool/headermaster&code=433821863_20221015&bizCode=30_4_2&classDingId=433821863&campusId=434054229&timeStamp=1665817207918&role=2&currentRole=2
    case '8':
      _toPath = '/afterschool/headermaster'
      break
    // dorm#宿管离寝考勤#宿管_班主任_其他角色  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f#/?redircetHash=/dorm/detail&dimDay=2022-11-14&dormGroupId=1709861441823047680&signTimePeriodId=7101630650782985&inOutType=2&campusId=154399516&role=2&dingDeptIds=442863501&tabIndex=0&type=1
    // dorm#宿管管理-归寝考勤#宿管_班主任_其他角色  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f#/?redircetHash=/dorm/detail&dimDay=2022-08-12&dormGroupId=1709682135528374272&signTimePeriodId=5701638180850252&inOutType=1&campusId=426025287&role=2&dingDeptIds=426030392&tabIndex=0&type=1
    case '9':
      _toPath = '/dorm/detail'
      break
    // squirrel#调代课申请审核通过#老师  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f#/?redircetHash=/substitute/detail&orgId=1638097460339408896&campusId=426025287&role=-1&currentRole=4&scheduleSubstituteId=1743298449417175040
    // squirrel#调代课申请审核通过#班主任_其他  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f#/?redircetHash=/substitute/detail&orgId=1638097460339408896&campusId=426025287&role=-1&scheduleSubstituteId=1743297281186070528
    // squirrel#调代课审核被退回#申请人  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f#/?redircetHash=/substitute/detail&orgId=1638097460339408896&campusId=426025287&role=-1&currentRole=4&scheduleSubstituteId=1743297246826332160
    // squirrel#调代课记录撤销#申请人  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f#/?redircetHash=/substitute/detail&orgId=1638097460339408896&campusId=426025287&role=-1&currentRole=4&scheduleSubstituteId=1743298449417175040
    // squirrel#调代课记录撤销#老师  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f#/?redircetHash=/substitute/detail&orgId=1638097460339408896&campusId=426025287&role=-1&currentRole=4&scheduleSubstituteId=1743296628351041536
    // squirrel#调代课记录被撤销#班主任_其他  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f#/?redircetHash=/substitute/detail&orgId=1638097460339408896&campusId=426025287&role=-1&currentRole=3&scheduleSubstituteId=1743298449417175040
    // squirrel#调代课审核通过#管理员  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f#/?redircetHash=/substitute/detail&orgId=1638097460339408896&campusId=426025287&role=-1&currentRole=3&scheduleSubstituteId=1743298122999660544
    case '10':
      _toPath = '/substitute/detail'
      break
    // squirrel#明日课表通知#家长  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f#/?redircetHash=/schedule/student&studentId=1609851421833796601705&role=1&tomorrow=1668441600000&orgId=1638097460339408896
    case '11':
      _toPath = '/schedule/student'
      break
    // squirrel#选课活动发布通知#家长  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f#/?redircetHash=/elective/student&strictAuth=1&stuDingId=3000000000024981368&currentRole=1&orgId=1638097460339408896
    case '12':
      _toPath = '/elective/student'
      break
    // squirrel#任课老师课后课堂评价#老师  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f#/?redircetHash=/classevaluation/list&courseName=信息技术&role=4&dateStr=20220809&courseEvaluationId=1740663839168397377&sectionNumber=8&campusId=426025287&teacherDingId=1150534119844344&currentRole=4&className=初一+(4)+班&courseEvaluationStatus=2&orgId=1638097460339408896
    case '13':
      _toPath = '/classevaluation/list'
      break
    // squirrel#德育评比审核通过#家长  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f#/?redircetHash=/classcard/moralstudent&operUserRoleType=1&role=1&campusId=426025287&startDimDay=20220815&endDimDay=20220821&studentDingId=3000000000025131352&orgId=1638097460339408896
    case '14':
      _toPath = '/classcard/moralstudent'
      break
    // squirrel#德育评比学生申请加分#老师  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f#/?redircetHash=/classcard/moralaudit&orgId=1638097460339408896&campusId=426025287&operUserRoleType=4&role=-1
    case '15':
      _toPath = '/classcard/moralaudit'
      break
    // squirrel#每日食谱#家长_老师  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f#/?redircetHash=/recipes/adminDaily&orgId=1638097460339408896&campusId=426025287&role=-1&currentRole=4&schoolYear=2022&startDay=20220905&endDay=20220911&dimDay=20220907&weekId=2&timestamp=1662519994821
    case '16':
      _toPath = '/recipes/adminDaily'
      break
    // 留言：http://tding.dev.moredian.com:8000/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f#/?redircetHash=%2Fclasscard%2Fclassrank%2Fmessage&currentRole=1&stuDingId=3000000000386085508
    case '17':
      _toPath = '/classcard/classrank/message'
      break
    // ********首页********
    // flexleave#放学通知#家长  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f&platformSource=1
    // flexleave#放学通知_学生进入等候区#家长  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f&platformSource=1
    // flexleave#滞留生#家长  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding7695755912aeb28035c2f4657eb6378f&platformSource=1
    // flexleave#放学通知_学生未准时离校#班主任_其他角色  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f&platformSource=1
    // flexleave#滞留生家长到达学校#班主任_其他角色  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f&platformSource=1
    // flexleave#滞留生学生离校#班主任  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f&platformSource=1
    // flexleave#学生留堂#家长  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f&platformSource=1
    // squirrel#任课老师课前通知#老师  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f&campusId=426025287&currentRole=4&operUserRoleType=4
    // squirrel#选课活动结束通知#家长  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding47900f8ef296f9dba1320dcb25e91351
    // squirrel#选课活动取消通知#家长  dingtalk://dingtalkclient/page/link?url=http://tding.test.moredian.com:8002/campusleave/?corpId=ding215f16be7cb2343135c2f4657eb6378f
    // 学生签到详情
    case '18':
      _toPath = '/studentSign/index'
      break
    // 行为管理首页
    case '19':
      _toPath = '/behavior/index'
      break
    case '20':
      _toPath = '/vehiclemanage/index?curPage=VehicleApproval'
      break
    case '21':
      _toPath = '/opendoor/group/parent/notice'
      break
    case '666':
      _toPath = '/other/authorize'
      break
    case '22':
      _toPath = '/meal/index'
      break
    case '23':
      _toPath = '/meal/calendar'
      break
    // 人脸录入信息
    case '24':
      _toPath = '/face/faceInfo'
      break
    // 亲情通话 家长端 未开通时弹窗提示开通
    case '25':
      _toPath = '/guardian?alertType=1&moduleId=29'
      break
    // 留言 家长端 未开通时弹窗提示开通
    case '26':
      _toPath = '/guardian?alertType=1&moduleId=22'
      break
    default:
      break
  }
  // 钉钉外链---leave#请假 - 通知#多角色 dingtalk://dingtalkclient/page/link?url\u003dhttps://aflow.dingtalk.com/dingtalk/mobile/homepage.htm?corpid=ding7695755912aeb28035c2f4657eb6378f&dd_share=false&showmenu=true&dd_progress=false&back=native&procInstId=lR9c97f7S9epK_CRGsPl_Q00381667789259&taskId=&dinghash=approval&dd_from=isv#approval
  // 钉钉外链---leave#请假-离校#多角色 dingtalk://dingtalkclient/page/link?url\u003dhttps://aflow.dingtalk.com/dingtalk/mobile/homepage.htm?corpid=ding215f16be7cb2343135c2f4657eb6378f&dd_share=false&showmenu=true&dd_progress=false&back=native&procInstId=7wCzJ21zQRKn5RIDfCsYvA03491667960212&taskId=&dinghash=approval&dd_from=isv#approval
  // 钉钉外链---leave#请假-取消#多角色 dingtalk://dingtalkclient/page/link?url\u003dhttps://aflow.dingtalk.com/dingtalk/mobile/homepage.htm?corpid=ding7695755912aeb28035c2f4657eb6378f&dd_share=false&showmenu=true&dd_progress=false&back=native&procInstId=lR9c97f7S9epK_CRGsPl_Q00381667789259&taskId=&dinghash=approval&dd_from=isv#approval
  return _toPath
}
/** ********************** 通知外链 *************************/
